import type { PropsWithChildren, ReactNode } from 'react'

import { nanoid } from 'nanoid'

import {
  DescriptionItemValueStyled,
  type IDescriptionItemValueStyledProps,
} from './styles/DescriptionItemValueStyled'
import {
  DescriptionItemLabelStyled,
  type IDescriptionItemLabelStyledProps,
} from './styles/IDescriptionItemLabelStyled'

export interface IDescriptionItemProps
  extends IDescriptionItemLabelStyledProps, IDescriptionItemValueStyledProps {
  labelFor?: string
  label: ReactNode
}

export const DescriptionItem = ({
  labelFor,
  label,
  children,
  padding,
  verticalAlignLabel,
}: PropsWithChildren<IDescriptionItemProps>) => {
  const useLabelFor = labelFor !== undefined
  const id = useLabelFor ? undefined : `dl-${nanoid(10)}`

  return (
    <>
      <DescriptionItemLabelStyled
        id={id}
        htmlFor={labelFor}
        verticalAlignLabel={verticalAlignLabel}
      >
        {label}
      </DescriptionItemLabelStyled>
      <DescriptionItemValueStyled aria-labelledby={id} padding={padding}>
        {children === null || children === undefined || children === ''
          ? '--'
          : children}
      </DescriptionItemValueStyled>
    </>
  )
}

DescriptionItem.displayName = 'DescriptionItem'
